import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'action-roles',
  templateUrl: './action-roles.component.html',
  styleUrl: './action-roles.component.scss'
})
export class ActionRolesComponent implements OnInit {
  
  roleForm: FormGroup;
  constructor(private fb: FormBuilder,private route: ActivatedRoute, private router: Router,) {
    this.roleForm = this.fb.group({
      thematicName: ['', Validators.required],
      roleName: ['', Validators.required]
    });
  }
  
  
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.roleForm.patchValue({
        thematicName: params['thematicName'] || '',
        roleName: params['roleName'] || ''
      });
    });
  }

  

  // thematicOptions = ['SISD-FNHW', 'Option 2', 'Option 3'];

  redirectToMasterPage() {
    this.router.navigate(['/master/role']);
  }
  onSubmit() {
    if (this.roleForm.valid) {
    }
  }
}
